module.exports = __webpack_public_path__ + "static/media/Drucker.7efa5021.svg";